import { createAsyncThunk } from "@reduxjs/toolkit";
import { RetrieveApi } from "api/retrieve";
import { WagerPayload } from "api/retrieve/type";

export const fetchAnnoucement = createAsyncThunk(
  "retrieve/retrieveAnnouncement",
  async (
    { page, size }: { page: number; size: number },
    { rejectWithValue }
  ) => {
    try {
      const response = await RetrieveApi.retrieveAnnoucement(page, size);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchBanner = createAsyncThunk(
  "retrieve/retrieveBanner",
  async (args, { rejectWithValue }) => {
    try {
      const response = await RetrieveApi.retriveBanner();
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchLogo = createAsyncThunk(
  "retrieve/retrieveLogo",
  async (args, { rejectWithValue }) => {
    try {
      const response = await RetrieveApi.retriveLogo();
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchWager = createAsyncThunk(
  "retrieve/fetchWager",
  async (formData: WagerPayload, { rejectWithValue }) => {
    try {
      const response = await RetrieveApi.retrieveWager(formData);

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
